import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  title: '',
  subtitle: '',
  welcomeDescription1: '',
  welcomeDescription2: '',
  servicesDescription: '',
  schoolDescription: '',
  contactDescription: '',
  phone: '',
  facebook: '',
  location: '',
};

const landingPageSlice = createSlice({
  name: 'landingPage',
  initialState,
  reducers: {
    setTitle: (state, action) => {
      state.title = action.payload;
    },
    setSubtitle: (state, action) => {
      state.subtitle = action.payload;
    },
    setWelcomeDescription1: (state, action) => {
      state.welcomeDescription1 = action.payload;
    },
    setWelcomeDescription2: (state, action) => {
      state.welcomeDescription2 = action.payload;
    },
    setServicesDescription: (state, action) => {
      state.servicesDescription = action.payload;
    },
    setSchoolDescription: (state, action) => {
      state.schoolDescription = action.payload;
    },
    setContactDescription: (state, action) => {
      state.contactDescription = action.payload;
    },
    setPhone: (state, action) => {
      state.phone = action.payload;
    },
    setFacebook: (state, action) => {
      state.facebook = action.payload;
    },
    setLocation: (state, action) => {
      state.location = action.payload;
    },
  },
});

export const {
  setTitle,
  setSubtitle,
  setWelcomeDescription1,
  setWelcomeDescription2,
  setServicesDescription,
  setSchoolDescription,
  setContactDescription,
  setPhone,
  setFacebook,
  setLocation,
} = landingPageSlice.actions;

export default landingPageSlice.reducer;
